import { IconBook } from "@/assets/icons/geist/IconBook";
import { IconGauge } from "@/assets/icons/geist/IconGauge";
import { cn } from "@/components/podkit/lib/cn";
import { SidebarButton } from "@/components/SidebarButton";
import { useOnboarding } from "@/hooks/use-onboarding";
import { useShowOnboarding } from "@/hooks/use-show-onboarding";
import { type FC } from "react";
import { useLocation } from "react-router-dom";
import { routeForStep } from "@/hooks/use-onboarding";

export const OnboardingSidebarSection: FC = () => {
    const location = useLocation();
    const onboarding = useOnboarding();
    const showOnboarding = useShowOnboarding();

    if (onboarding.steps.isLoading) {
        return;
    }

    const completedStepsCount = onboarding.steps.steps.filter((step) => step.completed).length;
    const to = routeForStep(onboarding.steps.defaultActive);
    const active = location.pathname.includes("/onboarding/");

    return (
        <div
            data-testid="onboarding-sidebar-section"
            aria-hidden={!showOnboarding}
            className={cn({ hidden: !showOnboarding })}
        >
            <SidebarButton
                icon={<IconBook size="lg" />}
                iconRight={<IconGauge size="lg" completed={completedStepsCount} />}
                label="Getting started"
                active={active}
                to={to}
            />
        </div>
    );
};
